// react
import React from "react";

// components
import Toggle from "../../../../components/Inputs/ToggleSwitches/ThumbSwitch";

// dependencies
import PropTypes from "../../../../lib/prop-types";

// utils
// styles
import css from "../SftpSettings.module.scss";

const AddTestingMode = (props) => {
	const { testingMode, setIsTestingMode } = props;

	return (
		<div className={`${css.inputWrapper} ${css.horizontalInputWrapper}`} style={{ width: "90%" }}>
			<div>
				<div className={css.modalDescription}>Testing Mode Enabled:</div>
				<div className={css.moreDescription}>
					If enabled, users will not be updated but you will still see logging information.
				</div>
			</div>

			<div className={css.modalInput}>
				<Toggle width={40} value={testingMode} onChange={(val) => setIsTestingMode(val)} />
			</div>
		</div>
	);
};

AddTestingMode.propTypes = {
	testingMode: PropTypes.bool.isRequired,
	setIsTestingMode: PropTypes.func.isRequired,
};

export default AddTestingMode;
